import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { NavigationBarAlertService } from 'ui-ng-navbar';
import { IDatasource } from 'utility-ts-orm';
import { HoldCapabilityConfiguration } from '../../../src/configuration';
import { Hold } from '../../builders/holds_builder';
import { HoldType } from './../../builders/holdtype_builder';
import { HoldModalService } from './../../hold_modal/hold_explanation_modal';
import { HoldsAttentionServant } from './../../servants/holds_attention_servant';

interface IHoldsDetailFlags {
  hasAdditionalInfoAmount: boolean;
  hasAdditionalInfoReason: boolean;
  hasDescription: boolean;
  hasResolutions: boolean;
  isHoldThatRequiresAttention: boolean;
}

interface IStatusBarService {
  setupStatusBarForHolds: (hasHolds: boolean) => void;
}

export class HoldsDetailContentController {
  private holdId: string;
  private holdTypeId: string;

  private hold: Hold;
  private holdType: HoldType;
  private flags: IHoldsDetailFlags;

  constructor(
    private ngHoldCapabilityConfiguration: HoldCapabilityConfiguration,
    private ngHoldModalService: HoldModalService,
    private ngHoldDatastore: IDatasource<Hold>,
    private ngHoldTypeDatastore: IDatasource<HoldType>,
    private loadHoldsListCommand: ICommand,
    private loadHoldResolutionCommand: ICommand,
    private updateHoldResolutionCommand: ICommand,
    private ngNavigationBarAlertService: NavigationBarAlertService
  ) {}

  $onInit() {
    this.refresh();
  }

  $onChanges() {
    this.refresh();
  }

  refresh() {
    this.hold = _4.first(this.ngHoldDatastore.query((hold: Hold) => hold.id === parseInt(this.holdId, 10)));
    this.holdType = _4.first(
      this.ngHoldTypeDatastore.query((type: HoldType) => type.id === parseInt(this.holdTypeId, 10))
    );
    this.flags = {
      hasAdditionalInfoAmount: !_4.isEmpty(_4.get(this.hold, 'amount', '')),
      hasAdditionalInfoReason: !_4.isEmpty(_4.get(this.hold, 'reason_text', '')),
      hasDescription: !_4.isEmpty(_4.get(this.hold, 'desc', '')),
      hasResolutions:
        !_4.isEmpty(_4.get(this.holdType, 'general_resolution', '')) ||
        !_4.isEmpty(_4.get(this.holdType, 'resolution_types', '')),
      isHoldThatRequiresAttention: HoldsAttentionServant.isHoldThatRequiresAttention(this.hold)
    };
    if (this.ngHoldCapabilityConfiguration.config.ngStatusBarService) {
      this.ngHoldCapabilityConfiguration.config.ngStatusBarService.setupStatusBarForHolds(
        this.flags.isHoldThatRequiresAttention
      );
      this.ngNavigationBarAlertService.toggleStateTo(this.flags.isHoldThatRequiresAttention);
    }

    this.__guarenteeContentExists();
  }

  showExplanation(): void {
    this.ngHoldModalService.isOpen = true;
  }

  private __guarenteeContentExists(): void {
    if (_4.isEmpty(this.hold)) {
      this.loadHoldsListCommand().then(() => this.refresh());
    }
    if (_4.isEmpty(this.holdType)) {
      this.loadHoldResolutionCommand(this.holdTypeId).then(() => {
        this.updateHoldResolutionCommand(this.hold.hold_type_id);
        this.refresh();
      });
    }
  }
}

export class HoldsDetailContentComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-holds/src/components/holds_detail_content/holds_detail_content.html';
  public controller: any = HoldsDetailContentController;
  public bindings: any = {
    holdId: '<',
    holdTypeId: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-holds/src/components/holds_detail_content/holds_detail_content_controller.ts